import type { State } from '../../reducers/types';
import { isColumnKnown } from '../columns';
import { isIssueKnown } from '../issues';

export const isCellValid = (state: State, columnId: string, rowId: string): boolean =>
	isIssueKnown(state, rowId) && isColumnKnown(state, columnId);
